import SessionCheck from './components/SessionCheck';

export const wrapRootElement = ({ element }) => (
  <SessionCheck>{element}</SessionCheck>
);
